import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { startTheme, stopTheme } from '../lib/soundEffects';
import { themeForPath } from '../lib/audio/soundManifest';
import { useAudioMuted } from './useAudioMuted';

/**
 * Plays the background theme the route table (`ROUTE_THEME_RULES`) assigns to the current page,
 * and silences it on pages with none. Mounted once, in the app shell. Pages that own their music
 * (`'self'`: the campaign, battles) are left alone. Un-muting restarts the page's theme.
 */
export function useRouteTheme() {
  const { pathname } = useLocation();
  const { muted } = useAudioMuted();

  useEffect(() => {
    const theme = themeForPath(pathname);
    if (theme === 'self') return;
    if (!theme) {
      stopTheme();
      return;
    }
    if (muted) return;
    startTheme(theme);
    return () => stopTheme(theme);
  }, [pathname, muted]);
}
